import {useState} from 'react'
import {InputCard} from './MergingInput'
import {QueryRequestProvider} from '../scrapping-table/core/QueryRequestProvider'
import {QueryResponseProvider} from '../scrapping-table/core/QueryResponseProvider'
import {ListViewProvider} from '../scrapping-table/core/ListViewProvider'
import {OutPutView} from './MergingOutput'
import {fetchPdfFileContent} from '../scrapping-table/core/_requests'

const MainMergingFiles = () => {
  const [tableloading, setTableLoading] = useState(false)
  const [data, setData] = useState('')
  const [pdfFiles, setPDFFiles] = useState<File[]>([])
  const [pdfContent, setpdfContent] = useState('')
  const [fetchingFileCount, setFetchingCount] = useState(0)

  const handleLoading = async () => {
    setTableLoading(true)
  }

  const callTheAPI = async (file: any) => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      const response = await fetchPdfFileContent(formData)
      const fileContent = response.content
      setpdfContent((prevData) => prevData + fileContent)
    } catch (error) {
      console.error('Error uploading file:', error)
    }
  }

  function timeout(delay: number) {
    return new Promise((res) => setTimeout(res, delay))
  }




  return (
    <div>
      <InputCard
        tableLoading={tableloading}
        handleTableLoading={handleLoading}
        searchTerm={pdfFiles}
      />
      
       <OutPutView data={data} clearData={setData} websiteUrl={'pdfFiles'} />
      
    </div>
  )
}

const MainMergingFilesWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <MainMergingFiles />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {MainMergingFilesWrapper}
